import { request } from 'root/common/request';
import env from './env';

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
/**
 * 反反弹，延迟函数的执行。
 * 使用方法参照：http://underscorejs.org/#debounce
 * @param {*} func 函数
 * @param {*} wait 延迟事件
 * @param {*} immediate 是否马上执行
 */
export function debounce(func, wait, immediate) {
    let timeout, result;

    let later = function(context, args) {
        timeout = null;
        if (args) result = func.apply(context, args);
    };

    let debounced = function(...args) {
        if (timeout) clearTimeout(timeout);
        // 如果immediate为true,则立即执行
        if (immediate) {
            let callNow = !timeout;
            timeout = setTimeout(later, wait);
            if (callNow) result = func.apply(this, args);
        } else {
            timeout = setTimeout(() => {
                return later(this, args);
            }, wait);
        }
        return result;
    };

    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = null;
    };

    return debounced;
}

export function showMissTokenDialog() {
    if (window.__is_blackApp && window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
        window.zzc.call('account_getInfo', {
            success: function(response) {
                if (response.data) {
                    let phopToken = response.data.token;
                    // 如果通过app 插件获取不了token，就重新登录，这是基于微信登录处理的
                    if (!phopToken) {
                        if (window.monitor) {
                            window.monitor.report({
                                level: 'error',
                                error: 'api',
                                url: window.location.href,
                                msg:
                                    'AppluginTokenInfo:' +
                                    JSON.stringify(response.data) +
                                    '|||' +
                                    window.navigator.userAgent,
                            });
                        }

                        showDialog();
                    }
                }
            },
        });
    } else {
        let token = localStorage.getItem('dolphin_token_from_jssdk') || localStorage.getItem('dolphin_token');

        if (!token) {
            showDialog();
        }
    }
}

function showDialog() {
    window.ZZCFL.Dialog(
        {
            title: '登录状态已过期，请重新登录',
            showCancelButton: false,
            confirmButtonText: '确认',
            cancelButtonText: '',
            closeOnClickModal: false,
        },
        /**
         * 按钮点中后的回调
         * @param  {[string]} value [description]
         * @return {[string]} 返回confirm  || cancel [description]
         */
        value => {
            if (value === 'confirm') {
                request({
                    url: `${window.location.origin}/logout`,
                    data: {},
                    method: 'get',
                    isNeedToken: false,
                }).then(() => {
                    window.localStorage.removeItem('token');
                    window.localStorage.removeItem('userId');
                    window.sessionStorage.removeItem('code');
                    window.localStorage.setItem('mine-page-need-reload', 1);

                    if (window.__is_blackApp) {
                        window.zzc.call('account_logoutSuccess', {
                            success: function(response) {
                                console.log('----通知原生退出登陆----');
                                console.log(response);

                                window.location.href = `${window.location.origin}/login`;
                            },
                        });
                    } else {
                        window.location.href = `${window.location.origin}/login`;
                    }
                });
            }
        }
    );
}

/**
 * 为请求增加域名
 * @template T
 * @param {T} urls
 * @param {string} domain
 * @returns {T}
 */
export function addDomain(urls, domain) {
    let newUrls = {};
    for (let key in urls) {
        newUrls[key] = `${domain}${urls[key]}`;
    }
    return newUrls;
}

//判断是否使用微信app支付
//iosMinVersion 最低兼容版本 格式1.3.0
//androidMinVersion 最低兼容版本 格式1.5.0
export function isGreaterVersion({
    iosMinVersion = '1.0.0',
    androidMinVersion = '1.0.0',
    harmoneyMiniVersion = '1.0.0',
}) {
    let minVersion;
    let ua = window.navigator.userAgent;
    let isIos = /ZZCIOS\/black/.test(ua);
    let isAndroid = /ZZCAndroid\/black/.test(ua);
    let isHarmony = /ZZCOpenHarmony\/black/.test(ua);
    if (isIos) {
        minVersion = iosMinVersion;
    } else if (isAndroid) {
        minVersion = androidMinVersion;
    } else if (isHarmony) {
        minVersion = harmoneyMiniVersion;
    } else {
        return false;
    }
    let minVersionArray = minVersion.split('.');

    let versionArray =
        ua
            .split('(')[0]
            .split('/')[2]
            .split('.') || [];

    if (Number(versionArray[0]) > Number(minVersionArray[0])) {
        return true;
    }
    if (
        Number(versionArray[0]) === Number(minVersionArray[0]) &&
        Number(versionArray[1]) > Number(minVersionArray[1])
    ) {
        return true;
    }
    if (
        Number(versionArray[0]) === Number(minVersionArray[0]) &&
        Number(versionArray[1]) === Number(minVersionArray[1]) &&
        Number(versionArray[2]) >= Number(minVersionArray[2])
    ) {
        return true;
    }

    return false;
}
// alert('大于2.0.6？: ' + isGreaterVersion({ iosMinVersion: '2.0.6', androidMinVersion: '2.0.6' }));
// alert('大于2.0.5？: ' + isGreaterVersion({ iosMinVersion: '2.0.5', androidMinVersion: '2.0.5' }));
// alert('大于2.0.0？: ' + isGreaterVersion({ iosMinVersion: '2.0.0', androidMinVersion: '2.0.0' }));
// alert('大于1.38.7？: ' + isGreaterVersion({ iosMinVersion: '1.38.7', androidMinVersion: '1.38.7' }));
// alert('大于1.38.6？: ' + isGreaterVersion({ iosMinVersion: '1.38.6', androidMinVersion: '1.38.6' }));
// alert('大于1.38.5？: ' + isGreaterVersion({ iosMinVersion: '1.38.5', androidMinVersion: '1.38.5' }));
// alert('大于1.0.0？: ' + isGreaterVersion({ iosMinVersion: '1.0.0', androidMinVersion: '1.0.0' }));

// 将对象转换成 url参数 ： a=xxx&b=xxx 这样的字符串
export function paramToStr(params = {}) {
    let paramArray = [];
    let keys = Object.keys(params);

    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (params[key] !== undefined) {
            paramArray.push(`${key}=${params[key]}`);
        }
    }
    return paramArray.join('&');
}

// 给URL添加参数
export function addParams(url, params) {
    let split = url.indexOf('?') === -1 ? '?' : '&';
    return `${url}${split}${paramToStr(params)}`;
}

// 给URL添加app参数
export function addAppParams(url, params) {
    let newurl = '';
    const paramsString = paramToStr(params);
    if (url.indexOf('ZZCAppArg=') !== -1) {
        const newurlarr = url.split('ZZCAppArg=');
        newurl = `${newurlarr[0]}ZZCAppArg=${params['ZZCAppArg']},${newurlarr[1]}`;
    } else if (url.indexOf('?') !== -1 && url.indexOf('#/') !== -1) {
        const newurlarr = url.split('?');
        newurl = `${newurlarr[0]}?${paramsString}&${newurlarr[1]}`;
    } else if (url.indexOf('#/') !== -1) {
        const newurlarr = url.split('#/');
        newurl = `${newurlarr[0]}?${paramsString}#/${newurlarr[1]}`;
    } else if (url.indexOf('?') !== -1) {
        newurl = `${url}&${paramsString}`;
    } else {
        newurl = `${url}?${paramsString}`;
    }
    return newurl;
}

export function getEntryCode(page, abRole) {
    let code = '';
    let word = '';
    switch (page) {
        case 'home':
            code = 2;
            break;
        case 'global_recommond': // 首页-精选推荐
            code = 8;
            break;
        case 'recommond': // 商城所有推荐列表（购物车、支付完成页等等）
            code = 4;
            break;
        case 'result':
            code = 1;
            break;
        case 'shop':
            code = 3;
            break;
        case 'list':
            code = 5;
            break;
        case 'freeBuy':
            code = 6;
            break;
        case 'scanPrice':
            // 扫码比价
            code = 14;
            break;
        case 'push':
            // 个性化推荐
            code = 15;
            break;
        // 整点秒杀
        case 'hourSeckill':
            code = 16;
            break;
        // case 'immersive':
        //     // 沉浸式
        //     code = 16;
        //     break;
        default:
            break;
    }
    word = abRole;
    return `${word}${code}`;
}

let iframeUniqueId = 1;
export function useIframeMiddle(url) {
    return new Promise(resolve => {
        const newIframe = document.createElement('iframe');
        let iframeId = `oneOffCommonIframe${iframeUniqueId++}`;
        newIframe.id = iframeId;
        let src = addParams(url, {
            ZZCAppArg: 'SelfOpenPage',
            t: new Date().getTime(),
        });
        newIframe.src = src;
        document.body.appendChild(newIframe);
        newIframe.style.cssText = 'position:fixed;top:999999px;left:999999px;';

        newIframe.onload = function() {
            let ifr = document.getElementById(iframeId);
            // ifr.contentWindow.postMessage('newIframeLoaded', '*');
            setTimeout(function() {
                if (document.body) {
                    document.body.removeChild(ifr);
                }
                resolve();
            }, 1000);
        };
    });
}

let uniqueId = 0;
export function getUniqueId() {
    return uniqueId++;
}

export function wait(timeout) {
    return new Promise(res => setTimeout(res, timeout));
}

/**
 * location 跳转
 * @param url
 * @param isReplace
 */
export const jumpLocation = (url, isReplace = false) => {
    const { location } = window;

    if (isReplace) {
        location.replace(
            addParams(url, {
                ZZCAppArg: 'SelfOpenPage',
            })
        );
        return;
    }

    location.href = url;
};

export const int = input => {
    if (!input) return 0;
    return Number(input);
};

export function downloadBlackUniqueApp() {
    window.location.href = '//a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';
}
/**
 * 打印本地日志
 * @param  {...any} args
 */
export function log(...args) {
    try {
        if (!window.monitor || !window.monitor.tempLog) return;
        window.monitor.tempLog(...args);
    } catch (error) {
        console.error(error);
    }
}

/**
 * 记录当前url到日志，用于跟踪用户轨迹
 */
export function trackUrl() {
    try {
        if (!window.monitor || !window.monitor.trackUrl) return;
        window.monitor.trackUrl();
    } catch (error) {
        console.error(error);
    }
}

/**
 * rem转px
 * @param {number} rem
 */
export function rem2px(rem) {
    return (document.documentElement.clientWidth / 7.5) * rem;
}
/**
 * 通过canvas将两张图合成一张图 通常用于将二维码、海报合成
 * @param {*}
 * width canvas宽度
 * height canvas高度
 * canvasBg canvas背景图
 * frontImg canvas拼接图
 * offsetX canvas拼接图x轴距离
 * offsetY canvas拼接图y轴距离
 * frontImgWidth canvas拼接图宽度
 * frontImgHeight canvas拼接图高度
 */
export function drawPosterImage({
    width = 750,
    height = 1523,
    bgImg,
    bgColor = '#fff',
    offsetX = 194,
    offsetY = 1335,
    frontImg,
    frontImgWidth = 136,
    frontImgHeight = 136,
}) {
    return new Promise(resolve => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        let context = canvas.getContext('2d');
        context.rect(0, 0, canvas.width, canvas.height);
        context.fillStyle = bgColor;
        context.fill();
        const myImage = new Image();
        myImage.crossOrigin = 'anonymous';
        myImage.src = bgImg; //背景图片 你自己本地的图片或者在线图片
        myImage.onload = function() {
            context.drawImage(myImage, 0, 0, canvas.width, canvas.height);
            let myImage2 = new Image();
            myImage2.crossOrigin = 'anonymous';
            myImage2.src = frontImg; //你自己本地的图片或者在线图片
            myImage2.onload = function() {
                context.drawImage(myImage2, offsetX, offsetY, frontImgWidth, frontImgHeight);
                let base64 = canvas.toDataURL('image/png'); //"image/png" 这里注意一下
                resolve(base64);
            };
        };
    });
}

export function navigateTo(router, routeParams, appArgs = {}) {
    const routerIns = router.resolve(routeParams);
    if (!env.isApp) {
        router.push({ ...routerIns.route });
        return;
    }

    const transformAppArgs = (args = {}) => {
        const argsMap = {
            topbarRemove: 'topbar_remove',
            appOpenPage: 'AppOpenPage',
            selfOpenPage: 'SelfOpenPage',
        };
        return (
            '_t=' +
            new Date().getTime() +
            ',ZZCAppArg=' +
            Object.keys(args)
                .map(key => {
                    const formatedArg = args[key] ? (argsMap[key] ? argsMap[key] : '') : '';
                    return formatedArg;
                })
                .filter(el => !!el)
                .join(',')
        );
    };
    const defaultAppArgs = {
        topbarRemove: false,
        appOpenPage: true,
        selfOpenPage: false,
    };
    const finalAppArgs = typeof appArgs === 'object' ? Object.assign(defaultAppArgs, appArgs) : appArgs;
    const formattedAppArgs = typeof finalAppArgs === 'object' ? transformAppArgs(appArgs) : finalAppArgs;
    const url = window.location.origin + window.location.pathname + '?' + formattedAppArgs + routerIns.href;
    window.location.href = url;
}

export function navigateBack() {
    if (env.isApp) {
        window.zzc.call('BackToPreviousPage', {
            success: function(response) {
                console.log(response);
            },
        });
        return;
    }
    window.history.go(-1);
}

export function setNavigationBarTitle(title) {
    window.document.title = title;
    if (env.isApp) {
        window.zzc.call('base_webviewTitle', {
            title,
        });
    }
}

// sleep
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
/**
 * 尝试用 iframe 唤起 APP
 * @param url
 * @param options
 * @returns {function(...[*]=)}
 */
export const callAppByIframe = (url, options = {}) => {
    options = {
        key: 'navigate',
        timeout: 5000,
        data: {},
        onTimeout: () => {
            window.location.href = url;
        },
        before: () => {},
        after: () => {},
        ...options,
    };
    const $iframe = document.createElement('iframe');
    const iframeId = '_call-app-iframe';
    $iframe.id = iframeId;
    $iframe.src = `${
        window.location.origin
    }/new/topic/views/callAppIframe/index.html?ZZCAppArg=SelfOpenPage&t=${Date.now()}`;
    document.body.appendChild($iframe);
    $iframe.style.cssText = 'position:fixed;top:999999px;left:999999px;';

    let timer = null;
    const remove = () => {
        if (document.body) {
            document.body.removeChild($iframe);
        }
    };
    const handleTimeout = () => {
        if (options.onTimeout && typeof options.onTimeout === 'function') {
            options.onTimeout();
        }
    };

    options.before();

    $iframe.onload = function() {
        var ifr = document.getElementById(iframeId);
        ifr.contentWindow.postMessage(
            {
                key: options.key,
                data: {
                    url,
                    ...options.data,
                },
            },
            '*'
        );
        timer = setTimeout(() => {
            options.after();
            remove();
            handleTimeout();
        }, options.timeout);
    };

    /**
     * 可以随时取消
     */
    return isExecuteTimeout => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
            options.after();
            remove();
            if (!isExecuteTimeout) return;
            handleTimeout();
        }
    };
};

export const leftPad = n => {
    if (n < 10) {
        return `0${n}`;
    }

    return `${n}`;
};

/**
 * 删除字符串左右两端的空格
 * @param {*} str
 */
export function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
}

/**
 * 简易的对象深对比
 * @param {*} v1
 * @param {*} v2
 */
export function isEqual(v1, v2) {
    const t1 = typeof v1;
    const t2 = typeof v2;
    if (v1 === v2) return true;
    if (Number.isNaN(v1) && Number.isNaN(v2)) return true;
    if (t1 !== t2) return false;
    if (t1 !== 'object') return false;
    if (Array.isArray(v1) && Array.isArray(v2)) {
        return v1.length === v2.length && v1.every((v, i) => isEqual(v, v2[i]));
    }
    if (Array.isArray(v1) || Array.isArray(v2)) return false;
    if (!v1 || !v2) return false;
    const keys1 = Object.keys(v1);
    const keys2 = Object.keys(v2);
    if (keys1.length !== keys2.length) return false;
    return keys1.every(key => isEqual(v1[key], v2[key]));
}

/**
 *
 * @param {*} fn
 * @param {*} threshold
 * @param {*} scope
 * 节流函数
 * @returns
 */
export function throttle(fn, threshold, scope) {
    var prev = 0;
    return function() {
        var context = scope || this,
            args = arguments;
        var now = Date.now();
        if (now - prev > threshold) {
            fn.apply(context, args);
            prev = now;
        }
    };
}

function isType(s, typeString) {
    return {}.toString.call(s) === `[object ${typeString}]`;
}

export function isArray(s) {
    return Array.isArray ? Array.isArray(s) : isType(s, 'Array');
}

/**
 * 判断是否测试环境
 */
export function isDev() {
    const hostname = window.location.hostname;
    const isDev = hostname !== 'm.black-unique.com' && (hostname.includes('box') || hostname.includes('test'));
    return isDev;
}
/**
 * 获取cookie的值
 * @param {*} cname
 */
export function getCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return '';
}

/*
测试
[
    !isEqual(1,2),
    isEqual(1,1),
    !isEqual(1,'1'),
    !isEqual(NaN,'1'),
    isEqual(NaN,NaN),
    !isEqual({a:1},{a:2}),
    isEqual({a:1},{a:1}),
    isEqual({},{}),
    isEqual({a:1,b:[]},{a:1,b:[]}),
    !isEqual({a:1,b:[1]},{a:1,b:[2]}),
    isEqual({a:1,b:[1]},{a:1,b:[1]}),
    isEqual({a:1,b:[1],c:{d1:1}},{a:1,b:[1],c:{d1:1}}),
    !isEqual({a:1,b:[1],c:{d1:1}},{a:1,b:[1],c:{d1:2}}),
    !isEqual({},null),
    isEqual(null,null),
    !isEqual({},undefined),
    isEqual(undefined,undefined),
    !isEqual(undefined,1),
    !isEqual(null,1),
    !isEqual(null,undefined),
]

 */

export function getOrderListUrl() {
    let url = `/new/orderList/index.html?ZZCAppArg=AppOpenPage,topbar_remove`;
    if (env.isApp && env.isHarmony) {
        url = `/new/orderList/index.html?ZZCAppArg=AppOpenPage,topbar_remove&status=0&orderType=priv_game,priv_carWash`;
    }
    return url;
}

export function checkIllegalAccount(account) {
    const illegalList = [
        [9728, 10175],
        [127744, 128591],
        [129280, 129535],
    ];
    for (const char of account) {
        const charNum = char.codePointAt(0);
        if (charNum >= illegalList[0][0] && charNum <= illegalList[0][1]) {
            return false;
        } else if (charNum >= illegalList[1][0] && charNum <= illegalList[1][1]) {
            return false;
        } else if (charNum >= illegalList[2][0] && charNum <= illegalList[2][1]) {
            return false;
        }
    }
    return true;
}
